import { Icons } from '@icons/icons';

import DynamicIconWrapper from '../DynamicIconWrapper';

import styles from './ColumnHeaderWithInfo.module.scss';

interface IColumnHeaderWithInfoProps {
	title: string;
	tooltip: string | JSX.Element;
}

const ColumnHeaderWithInfo = ({
	title,
	tooltip,
}: IColumnHeaderWithInfoProps) => (
	<span className={styles.columnHeader}>
		{title}
		<DynamicIconWrapper
			icon={Icons.info}
			tooltipLabel={tooltip}
		/>
	</span>
);

export default ColumnHeaderWithInfo;
